import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';

import { tValueSizing } from './tValues';

interface ProductSizingModalProps {
  readonly onSizeLinkClick: () => void;
}

const JapanSizeModal = ({ onSizeLinkClick }: ProductSizingModalProps) => {
  const t = useTranslations();

  return (
    <>
      <TypographyRhythm>
        <Typography variant="h1">
          {t('pdp_horizon_sizing_modal_title')}
        </Typography>
      </TypographyRhythm>
      <TypographyRhythm>
        <Typography variant="h6" weight="medium">
          {t('pdp_horizon_sizing_modal_expect')}
        </Typography>

        <Typography
          variant="body-small"
          color="unset"
          className="text-orange-500"
        >
          {t('pdp_horizon_sizing_modal_step_1_title')}
        </Typography>

        <Typography>
          {t('pdp_horizon_sizing_modal_step_1_description')}
        </Typography>

        <Typography
          variant="body-small"
          color="unset"
          className="text-orange-500"
        >
          {t('pdp_horizon_sizing_modal_step_2_title')}
        </Typography>

        <Typography>
          {t('pdp_horizon_sizing_modal_step_2_description')}
        </Typography>

        <Typography
          variant="body-small"
          color="unset"
          className="text-orange-500"
        >
          {t('pdp_horizon_sizing_modal_step_3_title')}
        </Typography>

        <Typography>
          {t('pdp_horizon_sizing_modal_step_3_description')}
        </Typography>

        <Typography>
          <RichText
            messageKey="pdp_horizon_sizing_modal_learn_more_watch"
            tValues={tValueSizing(onSizeLinkClick)}
          />
        </Typography>
      </TypographyRhythm>
    </>
  );
};
export default JapanSizeModal;
